class QuestionView {
  // Reference to the main element where the question will be rendered
  _parentElement = document.querySelector('#question');

  /**
   * Renders the current question inside the designated parent element.
   * @param {string} question - The question text to be displayed.
   */
  renderQuestion(question) {
    this._parentElement.innerHTML = question;
  }

  /**
   * Renders subcategory buttons based on the provided subcategories array.
   * @param {Array} subCategories - An array of subcategory names to be displayed as buttons.
   */
  renderSubCategories(subCategories) {
    // Reference to the element where subcategory buttons will be rendered
    const subCategoryOptions = document.querySelector('#subCategoryOptions');
    subCategoryOptions.innerHTML = ''; // Clear existing content

    // Generate the buttons for each subcategory and insert them into the DOM
    const subCategoriesContent =
      this._generateSubCategoryButtons(subCategories).join('');
    subCategoryOptions.insertAdjacentHTML('beforeend', subCategoriesContent);
  }

  /**
   * Generates an array of HTML button elements based on the provided subcategories.
   * @param {Array} subCategories - An array of subcategory names.
   * @returns {Array} An array of HTML button elements as strings.
   */
  _generateSubCategoryButtons(subCategories) {
    return subCategories.map(subCategory => `<button>${subCategory}</button>`);
  }

  /**
   * Adds an event listener to the "Next" button to handle clicks.
   * @param {Function} handler - The function to be called when the button is clicked.
   */
  addNextButtonHandler(handler) {
    document.querySelector('#nextButton').addEventListener('click', handler);
  }

  /**
   * Adds an event listener to the "Back" button to handle clicks.
   * @param {Function} handler - The function to be called when the button is clicked.
   */
  addBackButtonHandler(handler) {
    document.querySelector('#backButton').addEventListener('click', handler);
  }

  /**
   * Adds an event listener to the category dropdown to handle changes.
   * @param {Function} handler - The function to be called when the dropdown value changes.
   */
  addCategoryChangeHandler(handler) {
    document
      .querySelector('#categoryDropdown')
      .addEventListener('change', handler);
  }

  /**
   * Adds an event listener to the subcategory buttons container to handle clicks on any button.
   * @param {Function} handler - The function to be called when a subcategory button is clicked.
   */
  addSubCategoryChangeHandler(handler) {
    document
      .querySelector('#subCategoryOptions')
      .addEventListener('click', handler);
  }
}

// Export a singleton instance of QuestionView
export default new QuestionView();
